
namespace GeniuzPOS.InventoryReport {

    @Serenity.Decorators.registerClass()
    export class IcReport01Dialog extends Serenity.EntityDialog<IcReport01Row, any> {
        protected getFormKey() { return IcReport01Form.formKey; }
        protected getIdProperty() { return IcReport01Row.idProperty; }
        protected getLocalTextPrefix() { return IcReport01Row.localTextPrefix; }
        protected getNameProperty() { return IcReport01Row.nameProperty; }
        protected getService() { return IcReport01Service.baseUrl; }
        protected getDeletePermission() { return IcReport01Row.deletePermission; }
        protected getInsertPermission() { return IcReport01Row.insertPermission; }
        protected getUpdatePermission() { return IcReport01Row.updatePermission; }

        protected form = new IcReport01Form(this.idPrefix);
        protected getToolbarButtons(): Serenity.ToolButton[] {
            let buttons = super.getToolbarButtons();

            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "save-and-close-button"), 1);
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "apply-changes-button"), 1);
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "delete-button"), 1);

            return buttons;
        }
    }
}